import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {BitcoinAppConfig} from "./config/bitcoin-app.config";
import {BitcoinAppService} from "../../service/bitcoin-app/bitcoin-app.service";
import {SENETPRO_REDEEM_METHODS} from "../../pages/perks/perks.config";

@Component({
    selector: 'app-bitcoin-app',
    templateUrl: './bitcoin-app.component.html',
    styleUrls: ['./bitcoin-app.component.scss']
})
export class BitcoinAppComponent implements OnInit, OnDestroy {

    @Input() show = false;
    @Input() loaded = false;
    @Input() src = '';
    @Input() shortName = '';

    @Output('onClose') emitClose: EventEmitter<any> = new EventEmitter();

    safeUrl;
    activeClass = false;

    contentLoaded = false;
    appIsOpening = false;
    openPaypalTimeout: any;

    constructor(private sanitizer: DomSanitizer,
                private bitcoinAppService: BitcoinAppService) {}

    ngOnInit(): void {
      this.activeClass = true;
      this.safeUrl = this.getUrl();
    }

    ngOnChanges(changes) {
      if (changes && changes.loaded) {
        this.contentLoaded = changes.loaded.currentValue;
      }
    }

    ngOnDestroy() {
      this.contentLoaded = false;
      this.activeClass = false;
    }

    handleClose(): void {
        this.contentLoaded = false;
        this.emitClose.emit();
    }

    getUrl() {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
    }

  isPaypalIframe(): boolean {
    return this.shortName === BitcoinAppConfig.depositShortName.pyusd ||
           this.shortName === SENETPRO_REDEEM_METHODS.paypalPYUSD;
  }

  isCashAppUSDCIframe(): boolean {
    return this.shortName === BitcoinAppConfig.depositShortName.cashAppUSDC ||
      this.shortName === SENETPRO_REDEEM_METHODS.cashAppUSDC;
  }

  showFooter(): boolean {
      return this.isPaypalIframe() || this.isCashAppUSDCIframe();
  }

  openPaypal() {
    if (this.isPaypalIframe()) {
      this.bitcoinAppService.openPaypal();
    } else if (this.isCashAppUSDCIframe()) {
      this.bitcoinAppService.openCashAppUSDC();
    }

    if (this.openPaypalTimeout) clearTimeout(this.openPaypalTimeout);
    this.appIsOpening = true;
    this.openPaypalTimeout = setTimeout(() => {
      this.appIsOpening = false;
    }, BitcoinAppConfig.btnChangingTimeout);
  }
}
